import { get_user_info } from '../api/index'
import { ACTION_GET_USER_INFO, USRE_INFO_LOAD } from '../constant/eventbus'
import { click_event, error_event } from '../tools/mgtv/analysis'
import { clearCookie } from '../tools/mgtv/login'
import { isString } from '../tools/typeof'

const EventUser = {
  install: function (EventBus) {
    EventBus.$on(ACTION_GET_USER_INFO, (ticket) => {
      if (!ticket) {
        return;
      }
      get_user_info(ticket).then(res => {
        if (!res) {
          return;
        }

        if (res < 0) {
          return;
        }
        if (res.ret === 0) {

          const user_info = res.data.userinfo;
          let avatar = "//vipcdn.mgtv.com/upload3/201903/avatar-login.png";
          let avatars = user_info.avatar;
          if (isString(avatars) && avatars.length > 0) {
            avatars = JSON.parse(avatars);
            if (avatars.l) {
              avatar = avatars.l.replace(/^http:\/\//, "https://");
            }
          }

          let vip_id = 0;
          let level = 0;
          const vipinfo = user_info.vipinfo;
          if (vipinfo) {
            switch (vipinfo.type) {
              case "2": //黄钻 mpp
                vip_id = 1;
                break;
              case "1"://紫钻 ott
                vip_id = 2;
                break;
              default:
                vip_id = Number(vipinfo.type) || 0;
                break;
            }
            level = vipinfo.growth ? vipinfo.growth.level : 0;
            EventBus.$set(EventBus.user, 'type', vipinfo.type);
          }

          EventBus.$set(EventBus.user, 'uuid', user_info.uuid);
          EventBus.$set(EventBus.user, 'nickname', user_info.nickname);
          EventBus.$set(EventBus.user, 'avatar', avatar);
          EventBus.$set(EventBus.user, 'ticket', ticket);
          EventBus.$set(EventBus.user, 'vip_id', vip_id);
          EventBus.$set(EventBus.user, 'user_type', res.data.user_type);
          EventBus.$set(EventBus.user, 'level', level);
          EventBus.$set(EventBus.user, 'mobile', user_info.mobile);
          EventBus.$set(EventBus.user, 'relate_mobile', user_info.relate_mobile);
          EventBus.$set(EventBus.user, 'vip_end_time', vipinfo.vip_end_time);
          // 新增小屏svip信息
          EventBus.$set(EventBus.user, "is_mpp_svip", res.data.is_mpp_svip);
          EventBus.$set(EventBus.user, "mpp_svip_end_date", res.data.mpp_svip_end_date);

          EventBus.$emit(USRE_INFO_LOAD)

          if(window.__ac){
            window.__ac.uuid = user_info.uuid
          }
          setTimeout(()=>{
            click_event('成功获取用户信息')
          },0);
        } else {
          clearCookie();
          // window.$dialog.alert({
          //   message: '登录信息已过期，请重新登录'
          // }).then(() => {
          //   if (window.gact.is_h5) {
          //     logout()
          //   }
          // });

        }
      }).catch(error => {

        clearCookie();
        error_event(error,{code_error:"EventUser.ACTION_GET_USER_INFO"});
        // window.$dialog.alert({
        //   message: '登录信息已过期，请重新登录'
        // }).then(() => {
        //   if (window.gact.is_h5) {
        //     logout()
        //   }
        // });
      });
    });
  }
}

export default EventUser
